<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 대상년도 -->
          <c-datepicker
            type="month"
            default="today"
            label="년월"
            name="yearmonth"
            v-model="searchParam.yearmonth"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="search"
            :comboItems="completeItems"
            itemText="codeName"
            itemValue="code"
            name="completeFlag"
            label="진행상태"
            v-model="searchParam.completeFlag"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-checkbox
            :isFlag="true"
            trueLabel="기타 O"
            falseLabel="기타 X"
            label="기타(팀) 조회여부"
            name="etcFlag"
            v-model="searchParam.etcFlag"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="안전보건 목표 실적"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!--검색-->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'safetyHealthyTargetTeam',
  data() {
    return {
      searchParam: {
        plantCd: null,
        year: '',
        completeFlag: null,
        deptCd: '', // 로그인자의 부서
        etcFlag: 'N',
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            //사업장
            label: 'LBLPLANT',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'propelDeptName',
            field: 'propelDeptName',
            label: '제목',
            align: 'left',
            style: 'width:350px',
            sortable: true,
            type: 'link'
          },
          {
            name: 'yearmonth',
            field: 'yearmonth',
            label: '년월',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '해당팀',
            align: 'center',
            sortable: true,
            style: 'width:130px',
          },
          {
            name: 'completeFlagName',
            field: 'completeFlagName',
            label: '진행상태',
            align: 'center',
            style: 'width:150px',
            sortable: true,
          },
        ],
        data: [],
      },
      completeItems: [
        { code: 'Y', codeName: '완료' },
        { code: 'N', codeName: '작성중' },
      ],
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sai.safetyHealthy.dept.list.url;
      // code setting
      this.$set(this.searchParam, 'deptCd', this.$store.getters.user.deptCd)
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.popupOptions.title = '안전보건 목표 실적';
      this.popupOptions.param = {
        saiSafetyHealthyTargetMonthId: row.saiSafetyHealthyTargetMonthId,
        deptCd : row.deptCd
      };
      this.popupOptions.target = () => import(`${'./safetyHealthyTargetTeamDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
